// Package Imports
import { toJS } from "mobx";
import axios from "axios";

// Project Imports
import * as APITypes from "constants/API";
import AuthStore from "modules/login/store/AuthStore";
import updateProductwiseRiskData from "../updateProductwiseRiskData";
import generateChangeLADataStructure from "../change-la/generateChangeLADataStructure";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import StorageKeys from "constants/StorageKeys";
import updateChangeProductDataStructure from "./updateChangeProductDataStructure";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../../constants/Constants";

const changeProduct = async (productdata, selectedProduct) => {
  // Request Creation
  let newSelectedProduct = toJS(productdata)
  let needList = AuthStore.needMasterList;
  let changeProductDetails = toJS(OptimizationStore.changeProductData);
  let need = needList.find(
    (item) => item.unique_name == changeProductDetails.cardKey
  );

  let package_id = "";
  let investment_target = "";
  if (Array.isArray(changeProductDetails.data.BI)) {
    let riskProductData = changeProductDetails.data.BI.filter(
      (item) => item.risk == changeProductDetails.data.selectedRisk
    )[0];
    package_id = riskProductData.package_id;
    investment_target = riskProductData.selected_sum_Assured;
  } else {
    package_id = changeProductDetails.data.package_id;
    investment_target = changeProductDetails.data.selected_sum_Assured;
  }

  let requestObj = {
    family_product_id: newSelectedProduct.family_product_id,
    new_target_amount: investment_target===""?0:investment_target ,
    recommended_amount: changeProductDetails.data.recommended_sum_assured,
    user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
    need_id: need.id,
    family_member_id: changeProductDetails.data.id,
    previous_product: package_id,
    new_product: newSelectedProduct.package_id,
    risk_type: newSelectedProduct?.risk
  };
  // Update Data structure before api call for showing loader
  updateChangeProductDataStructure(changeProductDetails,newSelectedProduct);
  OptimizationStore.isChangeProductModalOpen = false;
  OptimizationStore.selectedReason = {};

  // API call
  let changeProductData = await axios.post(APITypes.CHANGE_PRODUCT, requestObj);

  if (changeProductData.status == "success") {
    localStorage.setItem(
      StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM,
      false
    );
    changeProductData.data = [changeProductData.data];
    // Update Data structure after api call
    updateProductwiseRiskData(changeProductData);
  }
};

export default changeProduct;
